<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{ limit?: number }>(), { limit: 50 })
const title = defineModel<string>({ required: true })

const trimmedTitle = computed(() => title.value.trim())
const overflowText = computed(() => trimmedTitle.value.slice(props.limit))
</script>

<template>
  <div class="mb-4">
    <label for="content-title" class="block mb-1 font-bold" :class="{ 'text-orange-300': overflowText }">Title</label>
    <input
      id="content-title"
      type="text"
      v-model.trim="title"
      :aria-describedby="overflowText ? 'content-title-limit' : undefined"
      class="w-full h-10 px-3 text-md !font-regular text-gray-900 bg-white border rounded-xs focus:outline-primary-400"
      :class="overflowText ? 'border-orange-300' : 'border-gray-600'"
    >
    <p v-if="overflowText" id="content-title-limit" class="mt-1 text-sm text-orange-300">
      Title is more than {{ limit }} characters (<b>{{ overflowText }}</b>)
    </p>
  </div>
</template>
